import { subscribe, broadcast } from '@gem/modules/eventBus';

function getBusStation() {
  return 'scroll-messages';
}

export const subscribeScrollMessages = (callback) => {
  return subscribe(getBusStation(), callback);
};

export const broadcastScrollMessages = () => {
  broadcast(getBusStation());
};
